import React from "react";
import { Grid, Typography } from "@mui/material";
import { EmptyNotiIcon } from "../../Components/Styles/Icons";

const Notification = () => {
  return (
    <Grid sx={{ px: { xs: 3, md: 8 }, py: 2 }}>
      <Grid
        sx={{
          mt: { md: 3, xs: 25 },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: { sm: 25, xs: 20 }, fontWeight: 700 }}>
          Notifications
        </Typography>
      </Grid>

      <Grid
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mt: 20,
        }}
      >
        <EmptyNotiIcon />
        <Typography sx={{ fontWeight: 600, fontSize: 25 }}>
          No New Notifications
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Notification;
